const selector = '[data-carousel]';
let $window;
let carousels;

function getSlidesToShow($el) {
  // data-carousel-up-to means this is only a carousel up to a given breakpoint
  if ($el.data('carousel-up-to') && $el.data('carousel-up-to') < window.globals.breakpoint) {
    return 0;
  }

  if ($el.data('carousel-items-per-slide')) {
    console.log($el.data('carousel-items-per-slide'));
    return $el.data('carousel-items-per-slide');
  }

  return Math.max(Math.floor($el.outerWidth() / ($el.data('carousel-item-width') || 320)), 1);
}

function getItemWidth($el) {
  const carouselWidth = $el.outerWidth() - parseInt($el.data('carousel-padding-right') || 0, 10);
  return parseInt(carouselWidth / getSlidesToShow($el), 10);
}

function checkSlidesToShow() {
  carousels.forEach(carousel => {
    const newSlidesToShow = getSlidesToShow(carousel.$el);
    if (newSlidesToShow !== carousel.slidesToShow) {
      clearTimeout(carousel.timeout);
      carousel.slidesToShow = newSlidesToShow;
      if (carousel.$el.hasClass('flickity-enabled')) {
        carousel.$el.flickity('destroy');
        carousel.timeout = setupCarouselTimeout(carousel);
      } else {
        carousel.timeout = setupCarouselTimeout(carousel);
      }
    }
  });
}

function setupCarousels() {
  const $els = $(selector);
  if ($els.length === carousels.length) {
    return;
  }
  $els.each(function(i) {
    const $el = $(this);
    if (!$el.data('carousel-is-setup')) {
      $el.data('carousel-is-setup', true);
      carousels.push({
        $el: $el,
        slidesToShow: getSlidesToShow($el),
        length: $el.children().length,
        contain: true,
        pageDots: true,
      });
      setupCarouselTimeout(carousels[i]);
    }
  });
}

function setupCarouselTimeout(carousel) {
  if (carousel.slidesToShow === 0 || carousel.length <= 1) {
    carousel.$el.removeClass('carousel');
    carousel.$el.children().removeAttr('style');
    return;
  }
  carousel.$el.addClass('carousel');
  if (carousel.$el.data('carousel-item-spacing')) {
    carousel.$el.children().not(':last-child').css('marginRight', `${carousel.$el.data('carousel-item-spacing')}px`);
  }
  if (carousel.$el.hasClass('flickity-enabled')) {
    carousel.$el.flickity('destroy');
  }
  clearTimeout(carousel.timeout);
  carousel.timeout = setTimeout(() => setupCarousel(carousel), 100);
}

function setupCarousel(carousel) {
  if (typeof carousel.$el.flickity === 'function') {
    carousel.$el.children().css('width', `${getItemWidth(carousel.$el)}px`);
    carousel.flickity = carousel.$el.flickity({
      cellAlign: 'left',
      groupCells: carousel.slidesToShow,
    });
  }
}

export default function() {
  $window = $(window);
  carousels = [];
  setupCarousels();
  $window.on('resize', checkSlidesToShow);
  $window.on('fpgmedia:post_loaded', setupCarousels);
}


// WEBPACK FOOTER //
// ./scripts/components/carousel.js